import {ApiV0} from "../../api.v0";
import {RestApiService} from "../../../rest-api.service";
import {
    BookedProductDetailsRes,
    BulkCompanyCreateReq,
    CompanyDetailsRes, CompanyOAuthSettingsRes, CompanyOAuthSettingsReq,
    CompanyUpdateReq,
    OnboardReq,
    OnboardRes,
} from '../../../../contracts/v0/cp';
import {Observable} from 'rxjs';
import {CompanyCreateReq} from '../../../../contracts/v0/crm';
import {BaseCollectionModel, Pagination, SearchModel} from '@yasc/yasc-material-components';
import {
    CompanyProjectStatsRes,
    ProjectStatsQueryReq
} from '../../../../contracts/v0/resource-manager/project-stats.contract';

export class ApiV0Company {
    segment = '/company';
    crmSegment = '/Company'

    constructor(v0: ApiV0, private rest: RestApiService) {
        this.crmSegment = v0.crmSegment + this.crmSegment;
        this.segment = v0.segment + this.segment;
    }

    onboard(dto: OnboardReq): Observable<OnboardRes> {
        return this.rest.post<OnboardReq, OnboardRes>(
            `${this.segment}/onboard`,
            OnboardRes,
            dto
        );
    }

    search(searchModel?: SearchModel): Observable<BaseCollectionModel<CompanyDetailsRes>> {
        searchModel ??= new SearchModel({
            pagination: new Pagination({
                size: 500,
                index: 0
            })
        })
        return this.rest.post<SearchModel, BaseCollectionModel<CompanyDetailsRes>>(`${this.segment}/search`, CompanyDetailsRes, searchModel)
    }

    details(id?: string): Observable<CompanyDetailsRes> {
        const url = id ? `${this.segment}/${id}` : `${this.segment}`;
        return this.rest.get<CompanyDetailsRes>(
            url,
            CompanyDetailsRes
        );
    }

    getBookedProducts(): Observable<BaseCollectionModel<BookedProductDetailsRes>> {
        return this.rest.get<BaseCollectionModel<BookedProductDetailsRes>>(
            `${this.segment}/Products`,
            BaseCollectionModel<BookedProductDetailsRes>
        );
    }

    create(createReq: CompanyCreateReq): Observable<CompanyDetailsRes> {
        return this.rest.post<CompanyCreateReq, CompanyDetailsRes>(`${this.crmSegment}`, CompanyDetailsRes, createReq);
    }

    bulkPost(createReq: BulkCompanyCreateReq): Observable<BaseCollectionModel<CompanyDetailsRes>> {
        return this.rest.post<BulkCompanyCreateReq, BaseCollectionModel<CompanyDetailsRes>>(this.crmSegment, CompanyDetailsRes, createReq)
    }

    update(company: CompanyUpdateReq): Observable<CompanyDetailsRes> {
        return this.rest.patch<CompanyUpdateReq, CompanyDetailsRes>(
            `${this.segment}/`,
            CompanyDetailsRes,
            company
        );
    }

    getContracts(id?: number) {
        return this.rest.get<BaseCollectionModel<BookedProductDetailsRes>>(
            `${this.segment}/products${id ? '?companyId=' + id.toString() : null}`,
            BaseCollectionModel<BookedProductDetailsRes>
        )
    }

    bulkDelete(ids: number[]) {
        return this.rest.delete<void>(this.segment, {}, ids)
    }

    oauthSettings() {
        return this.rest.get<CompanyOAuthSettingsRes[]>(`${this.segment}/oauth-settings`);
    }

    updateOAuthSettings(req: CompanyOAuthSettingsReq[]) {
        return this.rest.patch<CompanyOAuthSettingsReq[], BaseCollectionModel<CompanyOAuthSettingsRes>>(
            `${this.segment}/oauth-settings`,
            CompanyOAuthSettingsRes,
            req
        );
    }
}
